import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './SensorDetail.css';
import { FaArrowLeft } from 'react-icons/fa';
import { useSystem } from '../../context/SystemContext';
import { CSS_STATUS_CLASS } from '../../context/enums';
import { capitalizeFirst } from '../../utils/stringUtils';

/**SensorDetail component that displays the details of a sensor.*/
const SensorDetail = () => {
  const { sensorName } = useParams();
  const navigate = useNavigate();
  const { sensors, externalSensors, getDisplayStatus, getStatusColorClass, getSensorName } = useSystem();

  const allSensors = [...(sensors || []), ...(externalSensors || [])];

  const currentSensorData = allSensors.find(sensor => sensor.name === sensorName);

  const displayDetails = currentSensorData ? [
    { label: 'Name', value: getSensorName(currentSensorData.id) || 'N/A' },
    { label: 'Status', value: getDisplayStatus(currentSensorData.status) || 'Unknown' },
    { label: 'Connection', value: currentSensorData.connection ? capitalizeFirst(currentSensorData.connection) : 'Unknown' },
    { label: 'Data', value: currentSensorData.data || 'No Data' },
    { label: 'Last Update', value: currentSensorData.timeLastUpdate ?
      new Date(currentSensorData.timeLastUpdate).toLocaleString() : 'Never' }
  ] : [];

  const displayName = currentSensorData ? getSensorName(currentSensorData.id) : sensorName;
  const displayIcon = currentSensorData ? currentSensorData.icon : null;

  /**Handles the back button click event.*/
  const handleBack = () => {
    navigate('/system');
  };

  return (
    <div className="sensor-detail-page">
      <div className="sensor-detail-header">
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <div className="sensor-detail-title">
          {displayIcon && <div className="sensor-detail-icon">{displayIcon}</div>}
          <h2 style={{ margin: 0 }}>{displayName}</h2>
        </div>
      </div>

      <div className="sensor-detail-content">
        {currentSensorData ? (
          displayDetails.map((detail, index) => {
            const colorClass = detail.label === 'Status' ? getStatusColorClass(currentSensorData.status) : '';
            const alertClass = detail.value.toLowerCase().includes('error') ||
                              detail.value.toLowerCase() === 'disconnected' ||
                              detail.value.toLowerCase() === 'offline' ?
                              CSS_STATUS_CLASS.ALERT : '';
            return (
              <div key={index} className="detail-item">
                <div className="detail-label">{detail.label}</div>
                <div className={`detail-value ${colorClass || alertClass}`}>
                  {detail.value}
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-sensor-data">
            <div className="no-data-text">No sensor data available</div>
            <div className="no-data-subtext">
              Connect to a CBW device and ensure the {sensorName} sensor is available.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SensorDetail;
